import React from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import {capitalize} from '../../helpers/stringUtils';
import {getCaseStatusOptions} from '../../helpers/cases';
import config from '../../config/config';

const CaseStatus = props => {
  let showText = !!props?.case?.status;
  const {color, Icon, name} = getCaseStatusOptions(props?.case);
  return (
    <Stack
      direction='row'
      spacing={{xs: 1.5}}
      alignItems='center'
      onClick={props.onClick || undefined}
    >
      <Icon style={{fill: color, width: '15px', height: '15px'}} />
      {
        showText &&
          <Typography
            variant='normal'
            noWrap
          >
            {name}
          </Typography>
      }
    </Stack>
  );
};

export default CaseStatus;